export const CHAT_QNA_FIELD_TYPE = {
  TEXT: "text",
  NUMBER: "number",
  DATE: "date",
  FILE_UPLOAD: "file_upload",
  RADIO: "radio",
  FILING_CHOICE: "filing_choice",
  SELECT: "select",
  SELECT_AUTOFILL: "select_autofill",
  SELECT_SHAREHOLDER_AUTOFILL: "select_shareholder_autofill",
  SELECT_AUTHORIZED_SIGNATORY_AUTOFILL: "select_authorized_signatory_autofill",
} as const;

export type ChatQnAFieldType =
  (typeof CHAT_QNA_FIELD_TYPE)[keyof typeof CHAT_QNA_FIELD_TYPE];
